<template>
  <div class="login-container">
    <!-- 顶部波浪形红色背景 -->
    <div class="wave-bg"></div>
    
    <!-- 登录卡片 -->
    <div class="card-container">
      <div class="login-card">
        <!-- Logo图标 -->
        <div class="logo-container">
          <div class="logo">
            <svg class="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
            </svg>
          </div>
        </div>
        
        <h2 class="title">青年员工成长积分管理系统</h2>
        
        <form class="login-form" @submit.prevent="handleLogin">
          <div class="input-group">
            <div class="input-container">
              <span class="input-icon">
                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                </svg>
              </span>
              <input
                id="username"
                v-model="loginForm.username"
                type="text"
                required
                class="login-input"
                placeholder="用户名"
              />
            </div>
            
            <div class="input-container">
              <span class="input-icon">
                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
                </svg>
              </span>
              <input
                id="password"
                v-model="loginForm.password"
                type="password"
                required
                class="login-input"
                placeholder="密码"
              />
              <span class="password-toggle">
                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                </svg>
              </span>
            </div>
          </div>
          
          <button
            type="submit"
            :disabled="loading"
            class="login-button"
          >
            <span v-if="loading" class="spinner">
              <svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </span>
            <span>登录</span>
          </button>
        </form>
        
        <div class="dev-login">
          <a href="#" @click.prevent="handleDevLogin">开发者测试登录</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
        rememberMe: false
      },
      loading: false
    }
  },
  methods: {
    handleLogin() {
      // 先检查表单
      if (!this.loginForm.username || !this.loginForm.password) {
        alert('请输入用户名和密码')
        return
      }
      
      this.loading = true
      console.log('开始登录流程，提交数据:', JSON.stringify(this.loginForm))
      
      // 调用store action
      this.$store.dispatch('login', this.loginForm)
        .then(() => {
          console.log('登录成功，准备跳转')
          this.$router.push({ path: '/' })
        })
        .catch(error => {
          // 这里可以添加错误处理，例如显示错误消息
          console.error('登录失败详细信息:', error)
          let errorMsg = '登录失败'
          
          if (typeof error === 'string') {
            errorMsg = error
          } else if (error && error.message) {
            errorMsg = error.message
          } else if (error && typeof error === 'object') {
            errorMsg = JSON.stringify(error)
          }
          
          alert(`登录失败: ${errorMsg}`)
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleDevLogin() {
      // 开发者测试登录功能
      console.log('使用开发者账号登录')
      this.loginForm.username = 'admin'
      this.loginForm.password = '123456'
      this.handleLogin()
    }
  }
}
</script>

<style lang="scss" scoped>
@use "sass:color";

.login-container {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  overflow: hidden;
}

.wave-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 45%;
  background-color: #FA5050;
  border-radius: 0 0 50% 50% / 0 0 100px 100px;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 100px;
    background-color: #FA5050;
    border-radius: 0 0 50% 50% / 0 0 100% 100%;
  }
}

.card-container {
  position: relative;
  z-index: 10;
  max-width: 450px;
  width: 90%;
}

.login-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
  padding: 2rem;
  text-align: center;
}

.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.logo {
  width: 64px;
  height: 64px;
  background-color: #FA5050;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 2rem;
}

.login-form {
  margin-top: 1.5rem;
}

.input-group {
  margin-bottom: 1.5rem;
}

.input-container {
  position: relative;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  
  &:focus-within {
    border-color: #FA5050;
    box-shadow: 0 0 0 2px rgba(250, 80, 80, 0.1);
  }
}

.input-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.75rem;
}

.login-input {
  width: 100%;
  padding: 0.75rem 0.75rem 0.75rem 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.95rem;
  
  &::placeholder {
    color: #aaa;
  }
}

.password-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.75rem;
  cursor: pointer;
}

.login-button {
  width: 100%;
  padding: 0.75rem;
  background-color: #FA5050;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: color.adjust(#FA5050, $lightness: -5%);
  }
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.spinner {
  margin-right: 0.5rem;
}

.dev-login {
  margin-top: 1.5rem;
  font-size: 0.85rem;
  
  a {
    color: #888;
    text-decoration: none;
    
    &:hover {
      color: #FA5050;
      text-decoration: underline;
    }
  }
}
</style>
